import React from "react";
import Image from "next/image";
import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import Mobile from "public/assets/champion/mobile.png";
import All from "public/assets/champion/all.png";
import {
  Wrapper,
  Title,
  LeftWrapper,
  CardsWrapper,
  CardSection,
  Card,
  CardTitle,
  WrapperContainer,
  RightWrapper
} from "./akademi-student-type.styles";
import kamulah from "data/kamulah-card";

export const AkademiStudentType: React.FC = () => {
  const isLaptop = useMediaQuery("laptop");
  const isMobile = useMediaQuery("mobile");

  return (
    <Wrapper>
      <WrapperContainer>
        <LeftWrapper>
          {isLaptop && <Image src={All} alt="image" width={400} height={400} />}
          {isMobile && <Image src={Mobile} alt="colearn power up" />}
        </LeftWrapper>
        <RightWrapper>
          <Title>Kamulah yang CoLearn cari!</Title>
          <CardsWrapper>
            {kamulah.map((item, index) => (
              <CardSection key={index}>
                <Card>
                  <CardTitle
                    dangerouslySetInnerHTML={{ __html: item.normal[0] }}
                  />
                </Card>
              </CardSection>
            ))}
          </CardsWrapper>
        </RightWrapper>
      </WrapperContainer>
    </Wrapper>
  );
};
